module.exports = __webpack_public_path__ + "img/output_7.968e1689.png";